/**
 * @generated SignedSource<<984510cca6531b85892e9179c07c690f>>
 * @relayHash 2c7b16a276cca660dc92fe2f4d359892
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2c7b16a276cca660dc92fe2f4d359892

import { ConcreteRequest } from 'relay-runtime';
export type ChatSenderKind = "AGENT" | "PATIENT" | "SYSTEM";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type useOnChatChangedSubscription$variables = Record<PropertyKey, never>;
export type useOnChatChangedSubscription$data = {
  readonly onChatChanged: {
    readonly greeting: {
      readonly id: string;
      readonly received: boolean;
    } | null;
    readonly lastMessage: {
      readonly content: string | null;
      readonly createdOn: string | null;
      readonly id: string;
    } | null;
    readonly readState: {
      readonly hasUnread: boolean;
      readonly id: string;
      readonly unreadCount: number;
    } | null;
    readonly receivedMessage: {
      readonly message: {
        readonly content: string | null;
        readonly createdOn: string;
        readonly id: string;
        readonly metadata: {
          readonly aiFeatures: string | null;
          readonly autoTranslationBackTranslatedContent: string | null;
          readonly autoTranslationFailed: boolean | null;
          readonly autoTranslationOriginalContent: string | null;
          readonly autoTranslationTargetLanguage: Language | null;
          readonly autoTranslationTranslatedContent: string | null;
          readonly originalContent: string | null;
          readonly senderUserName: string | null;
        } | null;
        readonly participants: ReadonlyArray<{
          readonly displayName: string | null;
          readonly id: string | null;
        }>;
        readonly senderDisplayName: string | null;
        readonly senderId: string | null;
        readonly type: string;
      };
      readonly senderKind: ChatSenderKind;
      readonly threadId: string;
    } | null;
  };
};
export type useOnChatChangedSubscription = {
  response: useOnChatChangedSubscription$data;
  variables: useOnChatChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOn",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ChatChanged",
    "kind": "LinkedField",
    "name": "onChatChanged",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AppointmentChatLastMessage",
        "kind": "LinkedField",
        "name": "lastMessage",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          (v2/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ChatReadStateType",
        "kind": "LinkedField",
        "name": "readState",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unreadCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasUnread",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ChatMessageEvent",
        "kind": "LinkedField",
        "name": "receivedMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "threadId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "senderKind",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ChatMessage",
            "kind": "LinkedField",
            "name": "message",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              (v1/*:: as any*/),
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "senderId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "senderDisplayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatMessageMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aiFeatures",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "originalContent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "senderUserName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "autoTranslationOriginalContent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "autoTranslationTranslatedContent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "autoTranslationBackTranslatedContent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "autoTranslationTargetLanguage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "autoTranslationFailed",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatMessageParticipant",
                "kind": "LinkedField",
                "name": "participants",
                "plural": true,
                "selections": [
                  (v0/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AppointmentChatGreeting",
        "kind": "LinkedField",
        "name": "greeting",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "received",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useOnChatChangedSubscription",
    "selections": (v3/*:: as any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useOnChatChangedSubscription",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "id": "2c7b16a276cca660dc92fe2f4d359892",
    "metadata": {},
    "name": "useOnChatChangedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "60f50745dd1d2bcde6b349c0a817cf42";

export default node;
